import React from 'react';
import AdminEmailTemplateListContainer from '@src/components/administration/AdminEmailTemplateListContainer';

const AdminEmailTemplateListPage = () => <AdminEmailTemplateListContainer />;

export default AdminEmailTemplateListPage;
